export const STORE_TYPES = {
  PROJECT_CODE: {
    CDN: 'cdn',
    FILE_TRANSCODING: 'file-transcoding',
    LIVE_TRANSCODING: 'live-transcoding',
    DVR: 'dvr',
  },
  PROJECT_CODE_TO_TITLE: {
    cdn: 'CDN',
    'file-transcoding': 'File Transcoding',
    'live-transcoding': 'Live Transcoding',
    dvr: 'DVR',
  },
};
